import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'BaseLauncher' })({
    root: {
        display: 'flex',
        alignItems: 'center',
        gap: 24,
        flexWrap: 'wrap'
    },
    text: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        flex: 1000,
        minWidth: 320
    },
    title: {
        margin: 0,
        padding: 0,
        color: '#232323',
        fontSize: 20,
        fontWeight: 700,
        lineHeight: '150%',
        '& strong': {
            color: '#F5726A'
        }
    },
    description: {
        margin: 0,
        padding: 0,
        color: '#232323',
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '150%'
    }
});
